import { Box, Card, CardContent   } from '@mui/material';
import React from 'react';
import PrivacyPolicy from '../../PrivacyPolicy';
import Label from '../../../common/type/Label';
const PrivacyCard = () => {
    return (
    <Box className='securityBox'>
            <h3 className='privacypolicy-section'><Label id="settingsPrivacyPolicyLabel"/></h3>
      <Card className='flexbox'>
            <CardContent className='privacyPolicyContent'>
                <PrivacyPolicy/>
            </CardContent>
            </Card>
    </Box>
    );
};

export default PrivacyCard;
